import { gql } from "apollo-boost";
import { client } from "../App";

export const FindNumber = ({
  match: {
    params: { id }
  }
}) => {
  if (id.length === 37) {
    client
      .query({
        query: gql`
          query FindNumber($number: String) {
            findNumber(number: $number) {
              data
              type
            }
          }
        `,
        variables: {
          number: id
        }
      })
      .then(
        ({
          data: {
            findNumber: { data, type }
          }
        }) => {
          const parsedData = JSON.parse(data);
          if (type === "DocumentSet") {
            window.location.assign(
              "/section/5d3d8e33f7da1021cf46d2fe?checked=" +
                parsedData._id +
                "&box._id=" +
                parsedData.box._id
            );
          }
          if (type === "Box") {
            window.location.assign(
              "/section/5d3d8e33f7da1021cf46d2fe?box._id=" + parsedData._id
            );
          }
        }
      );
  }
  return null;
};
